import { STORE_KEY_LIST, useStorage, zones } from 'mailup-react-helpers'
import {
  contentScheduledState,
  INPUT_MINUTES_STEP,
  MAX_M,
  roundToClosestMultiple,
  TYPE_D,
  TYPE_H,
  TYPE_M
} from './state'
import moment from 'moment-timezone'

export const initDateCallback = ({ set, snapshot }) => async (
  scheduleDate,
  scheduleTimeZoneCode
) => {
  const [{ TimeZoneCode: listTimeZoneCode }] = useStorage(STORE_KEY_LIST).values
  const timeZone = scheduleTimeZoneCode || listTimeZoneCode

  const momentTimeZoneDate = moment
    .utc(scheduleDate || new Date().toISOString())
    .tz(zones[timeZone])

  const min = roundToClosestMultiple(
    momentTimeZoneDate.minutes(),
    INPUT_MINUTES_STEP
  )
  momentTimeZoneDate.set('minutes', min > MAX_M ? MAX_M : min)

  !scheduleDate && momentTimeZoneDate.add(INPUT_MINUTES_STEP, 'minutes')

  set(contentScheduledState, prev => ({
    ...prev,
    momentTimeZoneDate,
    momentUtcDate: momentTimeZoneDate.clone().utc(),
    timeZone
  }))
}

export const setDateCallback = ({ set, snapshot }) => async (
  type,
  value,
  timeZone
) => {
  const dateModel = await snapshot.getPromise(contentScheduledState)
  const tz = timeZone || dateModel.timeZone
  let momentTimeZoneDate

  if (type === TYPE_D) {
    // moment.utc(newBaseUtcDate).tz(zones[selectTimezone])
    if (!timeZone) {
      // se non c'è stato un cambio di timezone posso adeguare ora e minuti
      // l'utente ha selezionato un nuovo giorno
      const oldM = dateModel.momentTimeZoneDate.format('mm')
      const oldH = dateModel.momentTimeZoneDate.format('HH')
      momentTimeZoneDate = moment.tz(getLocaleDate(value), zones[tz])
      momentTimeZoneDate.set(TYPE_M, +oldM)
      momentTimeZoneDate.set(TYPE_H, +oldH)
    } else {
      momentTimeZoneDate = moment.tz(value, zones[tz])
    }
  } else {
    momentTimeZoneDate = dateModel.momentTimeZoneDate.clone()

    momentTimeZoneDate.set(type, +value)
  }
  // data selezionata in UTC
  const momentUtcDate = momentTimeZoneDate.clone().utc()
  // data e ora corrente
  //   const baseUtcDate = moment(new Date().toISOString()).utc()
  //   // i muniti devono essere arrotondati
  //   const minutes = roundToClosestMultiple(
  //     +baseUtcDate.format('mm'),
  //     INPUT_MINUTES_STEP
  //   )

  //   baseUtcDate.set('minutes', minutes)
  //   baseUtcDate.set('seconds', 0)

  // sempre valido
  const validDate = isValidDate(momentTimeZoneDate) // momentUtcDate.isAfter(baseUtcDate)

  if (validDate.valid) {
    set(contentScheduledState, prev => ({
      ...prev,
      validHour: true,
      validMinutes: true,
      validDate: true,
      boxError: false,
      showFeedback: false,
      momentTimeZoneDate,
      momentUtcDate,
      timeZone: tz,
      isDirty: true
    }))
  } else {
    // const validH =
    //   momentUtcDate.diff(baseUtcDate, 'hours') >= 0 &&
    //   momentUtcDate.hours() >= baseUtcDate.hours()
    // const validM = momentUtcDate.diff(baseUtcDate, 'minutes') >= 0
    // const validD =
    //   momentTimeZoneDate.diff(baseUtcDate, 'days') >= 0 &&
    //   momentTimeZoneDate.day() >= baseUtcDate.day()

    set(contentScheduledState, prev => ({
      ...prev,
      validHour: validDate.validH,
      validMinutes: validDate.validM,
      validDate: validDate.validD,
      momentTimeZoneDate,
      momentUtcDate,
      timeZone: tz,
      showFeedback: !(validDate.validH && validDate.validM && validDate.validD),
      isDirty: true
      // boxError: !(validH && validM && validD)
    }))
  }
}

export const verifyDateCallback = ({
  set,
  snapshot
}) => async momentTimeZoneDate => {
  return isValidDate(momentTimeZoneDate)
}

const isValidDate = momentTimeZoneDate => {
  // data selezionata in UTC
  const momentUtcDate = momentTimeZoneDate.clone().utc()
  // data e ora corrente
  const baseUtcDate = moment(new Date().toISOString()).utc()
  // const baseUtcDate = moment.tz(zones[timeZone]).utc()
  // i muniti devono essere arrotondati
  const minutes = roundToClosestMultiple(
    +baseUtcDate.format('mm'),
    INPUT_MINUTES_STEP
  )

  baseUtcDate.set('minutes', minutes + INPUT_MINUTES_STEP)
  baseUtcDate.set('seconds', 0)
  // sempre valido
  const validDate = momentUtcDate.isAfter(baseUtcDate)
  if (validDate) {
    return { valid: true } // valido
  } else {
    const validH =
      momentUtcDate.diff(baseUtcDate, 'hours') >= 0 &&
      momentUtcDate.hours() >= baseUtcDate.hours()
    const validM = momentUtcDate.diff(baseUtcDate, 'minutes') >= 0
    const validD =
      momentTimeZoneDate.diff(baseUtcDate, 'days') >= 0 &&
      momentTimeZoneDate.day() >= baseUtcDate.day()
    return { valid: validH && validM && validD, validH, validM, validD } // return true if date is valid
  }
}

const getLocaleDate = (jsDate = new Date(), locale = 'en-US') => {
  const convert = tmp => (tmp < 10 ? `0${tmp}` : `${tmp}`)
  const date = jsDate.toLocaleDateString(locale)
  const dateArray = date.split('/')
  const year = +dateArray[2]
  const month = convert(+dateArray[1])
  const day = convert(+dateArray[0])
  return `${year}-${day}-${month}`
}
